var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input-amount inactive",
      on: {
        "!click": function($event) {
          $event.stopPropagation()
          _vm.focusInput($event)
        }
      }
    },
    [
      _c("div", [
        _vm.value
          ? _c("span", [
              _vm._v(_vm._s(_vm._f("format-currency")(_vm.value, _vm.currency)))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          staticClass: "form-control",
          attrs: {
            type: "number",
            required: "",
            step: "any",
            disabled: _vm.disabled
          },
          domProps: { value: _vm.value },
          on: {
            focus: _vm.onInputFocus,
            blur: _vm.onInputBlur,
            input: _vm.onInput
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f4d84f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f4d84f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ui/widgets/input-amout.vue
// module id = 9Ip2
// module chunks = 3